/**
 * mtc-backoffice-api
 * MTC Backoffice Composite Api
 *
 * OpenAPI spec version: 0.1.0-SNAPSHOT
 * Contact: developers@greysystems.eu
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AgentBasic } from './agentBasic';
import { Amount } from './amount';
import { ExchangeRate } from './exchangeRate';


export interface ComposedTransferBasicInfo { 
    agentInfo?: AgentBasic;
    beneficiaryName?: string;
    blockedStatus?: ComposedTransferBasicInfo.BlockedStatusEnum;
    channel?: ComposedTransferBasicInfo.ChannelEnum;
    customerRate?: ExchangeRate;
    deliveryMode?: ComposedTransferBasicInfo.DeliveryModeEnum;
    destinationCountry?: string;
    id?: number;
    idAgent?: number;
    operationDate?: Date;
    payerCode?: string;
    payerName?: string;
    receiveAmount?: Amount;
    senderName?: string;
    sentAmount?: Amount;
    totalAmountPaidByCustomer?: Amount;
    totalFees?: Amount;
    transactionCode?: string;
    transferStatus?: ComposedTransferBasicInfo.TransferStatusEnum;
    type?: ComposedTransferBasicInfo.TypeEnum;
    urn?: string;
    watchedStatus?: ComposedTransferBasicInfo.WatchedStatusEnum;
}
export namespace ComposedTransferBasicInfo {
    export type BlockedStatusEnum = 'Blocked' | 'Unblocked';
    export const BlockedStatusEnum = {
        Blocked: 'Blocked' as BlockedStatusEnum,
        Unblocked: 'Unblocked' as BlockedStatusEnum
    };
    export type ChannelEnum = 'HomeTransfer' | 'Agent' | 'B2B';
    export const ChannelEnum = {
        HomeTransfer: 'HomeTransfer' as ChannelEnum,
        Agent: 'Agent' as ChannelEnum,
        B2B: 'B2B' as ChannelEnum
    };
    export type DeliveryModeEnum = 'Cash' | 'BankAccount' | 'HomeDelivery' | 'FamilySupport' | 'MobilePayment' | 'BillPayment' | 'MutualContributionPayment' | 'PrepaidCard' | 'CashAnywhere' | 'PrepaidCardAcquisition';
    export const DeliveryModeEnum = {
        Cash: 'Cash' as DeliveryModeEnum,
        BankAccount: 'BankAccount' as DeliveryModeEnum,
        HomeDelivery: 'HomeDelivery' as DeliveryModeEnum,
        FamilySupport: 'FamilySupport' as DeliveryModeEnum,
        MobilePayment: 'MobilePayment' as DeliveryModeEnum,
        BillPayment: 'BillPayment' as DeliveryModeEnum,
        MutualContributionPayment: 'MutualContributionPayment' as DeliveryModeEnum,
        PrepaidCard: 'PrepaidCard' as DeliveryModeEnum,
        CashAnywhere: 'CashAnywhere' as DeliveryModeEnum,
        PrepaidCardAcquisition: 'PrepaidCardAcquisition' as DeliveryModeEnum
    };
    export type TransferStatusEnum = 'Registered' | 'Cancelled' | 'CancelledImmediately' | 'Paid' | 'PaymentRollback';
    export const TransferStatusEnum = {
        Registered: 'Registered' as TransferStatusEnum,
        Cancelled: 'Cancelled' as TransferStatusEnum,
        CancelledImmediately: 'CancelledImmediately' as TransferStatusEnum,
        Paid: 'Paid' as TransferStatusEnum,
        PaymentRollback: 'PaymentRollback' as TransferStatusEnum
    };
    export type TypeEnum = 'Sending' | 'Receiving';
    export const TypeEnum = {
        Sending: 'Sending' as TypeEnum,
        Receiving: 'Receiving' as TypeEnum
    };
    export type WatchedStatusEnum = 'Watched' | 'Unwatched';
    export const WatchedStatusEnum = {
        Watched: 'Watched' as WatchedStatusEnum,
        Unwatched: 'Unwatched' as WatchedStatusEnum
    };
}
